import HeroSlider from "../components/HeroSlider";
import CTASection from "../components/CTASection";
import FAQItem from "../components/FAQItem";
import { STATS, FEATURES, BENEFITS, FAQS } from "../data/data";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

export default function HomePage({ setPage }) {
  return (
    <>

        <Helmet>
  <title>Millet Momos | Healthy Millet Food in India | No Maida Momos </title>
  <meta 
    name="description" 
    content="Enjoy healthy millet momos made without maida. Delicious, nutritious, and hygienic healthy fast food in Hyderabad." 
  />

  <meta name="keywords" content="millet momos, healthy food India, no maida snacks, millet recipes" />

  {/* Open Graph */}
  <meta property="og:title" content="Millet Momos" />
  <meta property="og:description" content="Healthy millet-based momos." />
  <meta property="og:image" content="https://milletmomos.com/images/momos.jpg" />
  <meta property="og:type" content="website" />
    <link rel="canonical" href="https://milletmomos.com/" />
  <script type="application/ld+json">
{JSON.stringify({
  "@context": "https://schema.org",
  "@type": "Restaurant",
  "name": "Millet Momos",
  "servesCuisine": "Healthy Food",
  "address": {
    "@type": "PostalAddress",
    "addressCountry": "India"
  }
})}
</script>
</Helmet>
      <HeroSlider setPage={setPage} />
 <section className="seo-content">
  <div className="seo-container">
    <h2>Best Healthy <span>Millet Momos</span> in Hyderabad</h2>
    
    <p>
      Looking for healthy momos in Hyderabad? Millet Momos offers delicious, steamed dumplings made with 100% natural millets. Unlike regular momos made with maida, our millet momos are rich in fiber, protein, and essential nutrients.
    </p>

    <p>
      Whether you're a fitness enthusiast, health-conscious eater, or simply love tasty street food, our millet dumplings are the perfect guilt-free snack. Order now and experience the taste of healthy comfort food.
    </p>
  </div>
</section>
      {/* Stats */}
      <section className="stats-section">
        <div className="stats-grid">
          {STATS.map((s, i) => (
            <div className="stat-item" key={i}>
              <div className="stat-icon"><img src={s.img} alt={s.label} className="icons-millet1"  loading="lazy" /></div>
              <div>
                <div className="stat-num">{s.num}</div>
                <div className="stat-label">{s.label}</div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Features teaser (3) */}
      <section className="features-section">
        <div className="sec-header">
          <h2 className="sec-title">Why Choose Healthy Millet Momos?</h2>
          <p className="sec-sub">Revolutionizing comfort food by combining traditional momos with the power of ancient supergrains</p>
        </div>
        <div className="features-grid">
          {FEATURES.slice(0, 3).map((f, i) => (
            <div className="feature-card" key={i}>
              <div className="feature-icon">  <img src={f.img} alt={f.title} className="icons-millet"  loading="lazy" /></div>
              <h3>{f.title}</h3>
              <p>{f.desc}</p>
            </div>
          ))}
        </div>
        <div style={{ textAlign: "center", marginTop: "2.2rem" }}>
          <Link className="btn-primary" style={{ cursor: "pointer" }} onClick={() => { setPage("about"); window.scrollTo(0, 0); }}>
            See All Benefits →
          </Link>
        </div>
      </section>

      {/* Millet highlights strip */}
      <section style={{ background: "var(--gray)", padding: "64px 5%" }}>
        <div className="sec-header">
          <h2 className="sec-title">Our Millet Selection</h2>
          <p className="sec-sub">Each millet brings unique health benefits and incredible flavours</p>
        </div>
        <div className="benefits-box" style={{ marginTop: "2rem" }}>
          <div className="benefits-hd"><h3>Quick Millet Benefits</h3></div>
          <div className="benefits-grid">
            {BENEFITS.map((b, i) => (
              <div className="benefit-item" key={i}>
                <div className="b-millet">{b.millet}</div>
                <div className="b-arrow">→</div>
                <div className="b-val">{b.value}</div>
              </div>
            ))}
          </div>
        </div>
        <div style={{ textAlign: "center", marginTop: "2.2rem" }}>
          <Link className="btn-primary" style={{ cursor: "pointer" }} onClick={() => { setPage("millets"); window.scrollTo(0, 0); }}>
            Explore All Millets →
          </Link>
        </div>
      </section>

      <CTASection setPage={setPage} />

      {/* FAQ (3 items on home) */}
      <section className="faq-section">
        <div className="faq-wrap">
          <div className="sec-header"><h2 className="sec-title">Frequently Asked Questions</h2></div>
          {FAQS.slice(0, 3).map((f, i) => <FAQItem key={i} item={f} />)}
          <div style={{ textAlign: "center", marginTop: "2rem" }}>
            <Link className="btn-primary" style={{ cursor: "pointer" }} onClick={() => { setPage("contact"); window.scrollTo(0, 0); }}>
              More FAQs →
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}